//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"AdvCompression",1,0],[0,"Angular",1,0],[0,"Chordal",1,0],[0,"FeatureSuppression",1,0],[0,"Label",1,0],[0,"Length",1,0],[0,"NxLabel",1,0],[0,"PerLODChordal",1,0],[0,"Resolution",1,0],[0,"Simplify",1,0],[0,"TessOption",1,0]],[],[]];
SPLM.ListCreator = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ListCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ListCreator.TessellationOption = Object.freeze({
    "Defined" : "Defined", "Lw" : "Lw", "Nx" : "Nx"});

SPLM.ListCreator.ResolutionType = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine", "UserDefined" : "UserDefined"});

SPLM.ListCreator.PerLodType = Object.freeze({
    "Absolute" : "Absolute", "Relative" : "Relative", "None" : "None"});

export default SPLM;